<template>
	<div>
		<el-dialog
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
			:visible.sync="isShowHint"
			center
			title="提示"
			top="30vh"
			width="40%">
			<div>
				<div style="margin-bottom: 30px">
					您本次批增起保日期为
					<span class="red-bold">{{ lastTimeData[0] }}</span>
					，受保司规则限制，此后在
					<span class="red-bold">{{ lastTimeData[1] }}</span>
					前本保单再批增起保日期将不得早于
					<span class="red-bold">{{ lastTimeData[0] }}</span>
					，请确认是否继续批增？
				</div>
				<div style="display: flex; justify-content: center">
					<el-button :disabled="currentDelayTime !== 0" type="primary" @click="onSure">
						我已悉知批增起保规则
						<span v-if="currentDelayTime !== 0">（{{ currentDelayTime }}）</span>
					</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

export default {
	name: 'endorseTimeHintDialog',
	mixins: [],
	components: {},
	props: {
		lastTimeData: {
			type: Array,
			required: true,
			default: () => {
				return ['', '']
			},
		},
	},
	data() {
		return {
			isShowHint: false,
			currentDelayTime: 5,
			intervalData: null,
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {},
	methods: {
		onShowDialog() {
			this.currentDelayTime = 5
			this.isShowHint = true
			this.onSetInterval()
		},
		onSure() {
			this.isShowHint = false
			this.$emit('onEndorseTimeSure')
		},
		onSetInterval() {
			this.intervalData = setInterval(() => {
				this.currentDelayTime--
				if (this.currentDelayTime <= 0) {
					clearInterval(this.intervalData)
					this.intervalData = null
				}
			}, 1000)
		},
	},
	created() {},
	mounted() {},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
	padding: 15px 30px;
}
</style>
